import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { 
  Calendar, 
  MessageSquare, 
  Star,
  CreditCard,
  Settings,
  User,
  Search,
  LogOut,
  CheckCircle,
  X,
  Heart,
  Bell,
  HelpCircle,
  FileText,
} from 'lucide-react';

const ClientSidebar = ({ isMobileOpen, onClose }) => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  const navigationItems = [
    {
      name: 'My account',
      href: '/dashboard',
      icon: User
    },
    {
      name: 'My Bookings',
      href: '/bookings',
      icon: Calendar
    },
    {
      name: 'Browse Vendors',
      href: '/browse-vendors',
      icon: Search
    },
    {
      name: 'Favorites',
      href: '/favorites',
      icon: Heart
    },
    // {
    //   name: 'Site message',
    //   href: '/messages',
    //   icon: MessageSquare
    // },
    {
      name: 'Notifications',
      href: '/notifications',
      icon: Bell
    },
    {
      name: 'My Reviews',
      href: '/reviews',
      icon: Star
    },
    // {
    //   name: 'Billing Details',
    //   href: '/billing',
    //   icon: CreditCard
    // },
    // {
    //   name: 'Transaction History',
    //   href: '/transactions',
    //   icon: FileText
    // },
    {
      name: 'Help & Support',
      href: '/help',
      icon: HelpCircle
    },
    {
      name: 'Settings',
      href: '/settings',
      icon: Settings
    }
  ];

  return (
    <>
      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar */}
      <div className={`
        w-full lg:w-64 flex-shrink-0
        ${isMobileOpen 
          ? 'fixed inset-y-0 left-0 z-50 lg:relative lg:z-auto' 
          : 'hidden lg:block'
        }
        transition-transform duration-300 ease-in-out
      `}>
        <div className="bg-white rounded-lg lg:rounded-lg border border-gray-200 h-full lg:h-auto lg:sticky lg:top-24 flex flex-col">
          {/* Mobile Close Button */}
          {isMobileOpen && (
            <div className="flex items-center justify-between p-4 border-b-2 border-black lg:hidden">
              <h2 className="text-lg font-bold text-black">Menu</h2>
              <button
                onClick={onClose}
                className="p-2 text-black hover:bg-gray-100 rounded-lg transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          )}

          {/* Profile Section */}
          <div className="p-4 sm:p-6 border-b-2 border-gray-300">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white font-medium text-sm">
                  {user?.name ? user.name.charAt(0).toUpperCase() : 'C'}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-black truncate">
                  {user?.name || 'Client'}
                </p>
                <p className="text-xs text-gray-600 truncate">
                  {user?.email || ''}
                </p>
                <div className="flex items-center mt-1">
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-black text-white">
                    <CheckCircle className="w-3 h-3 mr-1" />
                    Active
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="p-2 sm:p-4 space-y-1 flex-1 overflow-y-auto">
            {navigationItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                onClick={() => {
                  if (isMobileOpen && onClose) {
                    onClose();
                  }
                }}
                className={({ isActive }) =>
                  `flex items-center px-3 py-2.5 sm:py-3 text-sm font-light rounded-lg transition-colors ${
                    isActive
                      ? 'bg-gray-600 text-white'
                      : 'text-gray-700 hover:bg-gray-100 hover:text-black'
                  }`
                }
              >
                <item.icon className="w-5 h-5 mr-3 flex-shrink-0" />
                <span>{item.name}</span>
              </NavLink>
            ))}
          </nav>

          {/* Logout Section */}
          <div className="p-2 sm:p-4 border-t-2 border-gray-300">
            <button
              onClick={handleLogout}
              className="flex items-center w-full px-3 py-2.5 sm:py-2 text-sm font-medium text-black hover:bg-gray-100 rounded-lg transition-colors"
            >
              <LogOut className="w-5 h-5 mr-3 flex-shrink-0" />
              <span>Sign Out</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientSidebar;
